import { render, staticRenderFns } from "./WechatReply.vue?vue&type=template&id=87762f54&"
import script from "./WechatReply.vue?vue&type=script&lang=js&"
export * from "./WechatReply.vue?vue&type=script&lang=js&"
import style0 from "./WechatReply.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports